import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  NavLink,
  Alert
} from "reactstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { register } from "../../../actions/authActions";
import { clearErrors } from "../../../actions/errorActions";
import "./RegistrarModal.css";

class RegistrarModal extends Component {
  state = {
    modal: false,
    name: "",
    email: "",
    password: "",
    tipo: "Cliente",
    msg: null
  };

  static propTypes = {
    error: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    clearErrors: PropTypes.func.isRequired
  };

  componentDidUpdate(prevProps) {
    const { error } = this.props;
    if (error !== prevProps.error) {
      // Verifica erros ao registar
      if (error.id === "REGISTER_FAIL") {
        this.setState({ msg: error.msg.msg });
      } else {
        this.setState({ msg: null });
      }
    }
  }

  toggle = () => {
    // Clear errors
    this.props.clearErrors();
    this.setState({
      modal: !this.state.modal
    });
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = e => {
    e.preventDefault();

    const { name, email, password, tipo } = this.state;

    // Create user object
    const newUser = {
      name,
      email,
      password,
      tipo
    };

    // Tentativa de registrar
    this.props.register(newUser);

    this.toggle();
  };

  render() {
    return (
      <div>
        <NavLink onClick={this.toggle} href="#">
          Registrar
        </NavLink>

        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Registrar</ModalHeader>
          <ModalBody>
            {this.state.msg ? (
              <Alert color="danger">{this.state.msg}</Alert>
            ) : null}
            <Form onSubmit={this.onSubmit}>
              <FormGroup>
                <Label for="name">Nome</Label>
                <Input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Nome"
                  className="mb-3"
                  onChange={this.onChange}
                />

                <Label for="email">Email</Label>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email"
                  className="mb-3"
                  onChange={this.onChange}
                />

                <Label for="password">Password</Label>
                <Input
                  type="password"
                  name="password"
                  id="password"
                  placeholder="Password"
                  className="mb-3"
                  onChange={this.onChange}
                />

                <Label for="tipo">Tipo de conta</Label>
                <select
                  value={this.state.tipo}
                  name="tipo"
                  onChange={this.onChange}
                  className="p-2 mb-3 tipoConta"
                >
                  <option value="Cliente">Cliente</option>
                  <option value="Editor">Editor</option>
                  <option value="Administrador">Administrador</option>
                </select>

                <Button color="dark" className="registrarButton" block>
                  Registrar
                </Button>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: state.error
});

export default connect(mapStateToProps, { register, clearErrors })(
  RegistrarModal
);
